import { motion } from 'framer-motion';
import { Code2, Rocket } from 'lucide-react';
import { useLang } from '@/lib/LanguageContext';
import { Link } from 'react-router-dom';

const paths = [
  { icon: Code2, title: 'Technology Services', text: 'We build AI, software and cybersecurity for businesses, founders and institutions.', cta: 'Get a Quote', href: '/contact' },
  { icon: Rocket, title: 'Venture Building', text: 'We design, engineer and launch our own products across AI, security, fintech and emerging tech.', cta: 'Explore Ventures', href: '#ventures' }
];

export default function BusinessModel() {
  const { t } = useLang();
  return (
    <section className="relative py-24 px-6 lg:px-8">
      <div className="max-w-5xl mx-auto text-center">
        <span className="text-xs font-inter font-semibold tracking-[0.3em] uppercase text-primary">{t('Our Model')}</span>
        <h2 className="mt-4 font-inter font-black text-3xl md:text-5xl tracking-[-0.03em] text-foreground">{t('More Than a Technology Agency')}</h2>
        <p className="mt-6 max-w-3xl mx-auto text-muted-foreground font-inter font-light leading-relaxed">
          {t('Jotunheims operates at the intersection of technology services and venture building. We build technology for ambitious organizations while developing our own AI, software, cybersecurity and emerging-tech ventures in-house.')}
        </p>
        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {paths.map(({ icon: Icon, title, text, cta, href }, i) => (
            <motion.div key={title} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.15 }}
              className="p-8 rounded-xl border border-border/50 bg-card/40 text-left">
              <Icon className="w-6 h-6 text-primary" aria-hidden="true" />
              <h3 className="mt-4 font-inter font-bold text-lg text-foreground">{t(title)}</h3>
              <p className="mt-2 text-sm text-muted-foreground font-inter">{t(text)}</p>
              {href.startsWith('/') ? (
                <Link to={href} className="inline-block mt-5 text-xs font-inter font-semibold tracking-wider uppercase text-primary hover:underline">{t(cta)} →</Link>
              ) : (
                <a href={href} onClick={(e) => { const el = document.querySelector(href); if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth' }); } }} className="inline-block mt-5 text-xs font-inter font-semibold tracking-wider uppercase text-primary hover:underline">{t(cta)} →</a>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}